import { Testable } from "~/lib/testing";
import { JoinButton } from "~/components/molecules/JoinButton";
import { cn, getAuthUrls } from "~/lib/utils";
import { RouteIds, useRouteData } from "~/lib/routing";
import { Link, useLocation } from "react-router";

interface Props extends Testable {
    className?: string;
}

export default function LeadFormCTA({ "data-testid": testId, className }: Props) {
    const { FEATURES } = useRouteData(RouteIds.ROOT);
    const location = useLocation();
    const returnTo = `${location.pathname}${location.search}`;
    const { login } = getAuthUrls({ returnTo });

    return (
        <div
            className={cn(
                "card flex h-auto w-full flex-col items-center justify-between gap-8 p-8 text-center text-base text-gray-80 lg:sticky lg:top-4 lg:z-30",
                className,
            )}
        >
            <div className="font-header-small lg:font-header-xs uppercase text-blue-80">
                GET NOTICED WITH YOUR NCSA PROFILE TODAY
            </div>
            <div className="font-metadata-medium">
                Join the 300k+ athletes who have used NCSA to get recruited to play their sport in
                college.
            </div>
            <JoinButton size="lg" data-testid={testId} returnTo={returnTo} />
            {FEATURES.BETAExperience && (
                <div className="font-metadata-medium">
                    Already have an account?{" "}
                    <Link className="text-blue-80" to={login}>
                        Log In
                    </Link>
                </div>
            )}
        </div>
    );
}
